"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _imageUrlModifier = require("../../../utils/imageUrlModifier/imageUrlModifier");
var _LoadingSpinner = require("../../loading-spinner/LoadingSpinner");
var _imageModule = _interopRequireDefault(require("./image.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Image = function Image(_ref) {
  var _ref$alternativeImage = _ref.alternativeImageUrls,
    alternativeImageUrls = _ref$alternativeImage === void 0 ? [] : _ref$alternativeImage,
    _ref$aspectRatio = _ref.aspectRatio,
    aspectRatio = _ref$aspectRatio === void 0 ? 0.75 : _ref$aspectRatio,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? undefined : _ref$className,
    _ref$handleClick = _ref.handleClick,
    handleClick = _ref$handleClick === void 0 ? function () {} : _ref$handleClick,
    _ref$hasAltImageOnHov = _ref.hasAltImageOnHover,
    hasAltImageOnHover = _ref$hasAltImageOnHov === void 0 ? false : _ref$hasAltImageOnHov,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? '' : _ref$image,
    _ref$imageRef = _ref.imageRef,
    imageRef = _ref$imageRef === void 0 ? undefined : _ref$imageRef,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? 'lazy' : _ref$loading,
    _ref$multipleSwatches = _ref.multipleSwatches,
    multipleSwatches = _ref$multipleSwatches === void 0 ? false : _ref$multipleSwatches,
    _ref$selectedSwatch = _ref.selectedSwatch,
    selectedSwatch = _ref$selectedSwatch === void 0 ? {} : _ref$selectedSwatch,
    _ref$sizes = _ref.sizes,
    sizes = _ref$sizes === void 0 ? '(max-width: 567px) 50vw, (min-width: 568px) and (max-width:768px) 33vw, 20vw' : _ref$sizes,
    _ref$srcSetWidths = _ref.srcSetWidths,
    srcSetWidths = _ref$srcSetWidths === void 0 ? ['160', '320', '540'] : _ref$srcSetWidths,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? '' : _ref$url,
    _ref$hasLoadingSpinne = _ref.hasLoadingSpinner,
    hasLoadingSpinner = _ref$hasLoadingSpinne === void 0 ? false : _ref$hasLoadingSpinne;
  var imageUrl = multipleSwatches && selectedSwatch !== null && selectedSwatch !== void 0 && selectedSwatch.imageUrl ? selectedSwatch.imageUrl : image;
  var hasAlternativeImages = (alternativeImageUrls === null || alternativeImageUrls === void 0 ? void 0 : alternativeImageUrls.length) > 0 && ((0, _isEmpty.default)(selectedSwatch) || (selectedSwatch === null || selectedSwatch === void 0 ? void 0 : selectedSwatch.imageUrl) === image);
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    showLoadingSpinner = _useState2[0],
    setShowLoadingSpinner = _useState2[1];
  var isAltImageOnHoverEnabled = hasAltImageOnHover && hasAlternativeImages;
  var determineSrcSetArr = function determineSrcSetArr(urlOfImage) {
    return srcSetWidths.map(function (width) {
      return "".concat((0, _imageUrlModifier.modifyImageUrlQueryParams)(urlOfImage, {
        wid: width,
        hei: Math.round(width / aspectRatio)
      }), " ").concat(width, "w");
    });
  };
  var srcSetArr = determineSrcSetArr(imageUrl);
  var altImageSrcSetArr = hasAlternativeImages ? determineSrcSetArr(alternativeImageUrls[0]) : [];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("a", {
    "aria-hidden": "true",
    className: (0, _classnames.default)(_imageModule.default.imageLink, className),
    href: url,
    onClick: handleClick,
    tabIndex: "-1",
    children: [hasLoadingSpinner && showLoadingSpinner && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _imageModule.default.loadingSpinnerContainer,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingSpinner.LoadingSpinner, {
        className: _imageModule.default.loadingSpinner,
        size: "extra-large"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      ref: imageRef,
      alt: selectedSwatch !== null && selectedSwatch !== void 0 && selectedSwatch.color ? "".concat(title, ", ").concat(selectedSwatch.color) : title,
      className: (0, _classnames.default)(_imageModule.default.image, _defineProperty({}, _imageModule.default['image--isLoading'], hasLoadingSpinner && showLoadingSpinner)),
      "data-testid": "product-card-image",
      height: Math.round(250 / aspectRatio),
      loading: loading,
      onLoad: hasLoadingSpinner ? function () {
        setShowLoadingSpinner(false);
      } : null,
      sizes: sizes,
      src: srcSetArr[0].split(' ')[0],
      srcSet: srcSetArr.join(', '),
      width: "250"
    }), isAltImageOnHoverEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      alt: selectedSwatch !== null && selectedSwatch !== void 0 && selectedSwatch.color ? "".concat(title, ", ").concat(selectedSwatch.color) : title,
      className: (0, _classnames.default)(_imageModule.default.altImage),
      "data-testid": "product-card-alt-image",
      height: Math.round(250 / aspectRatio),
      loading: loading,
      sizes: sizes,
      src: altImageSrcSetArr[0].split(' ')[0],
      srcSet: altImageSrcSetArr.join(', '),
      width: "250"
    }) : null]
  });
};
Image.propTypes = {
  alternativeImageUrls: _propTypes.default.arrayOf(_propTypes.default.string),
  aspectRatio: _propTypes.default.number,
  className: _propTypes.default.string,
  handleClick: _propTypes.default.func,
  hasAltImageOnHover: _propTypes.default.bool,
  image: _propTypes.default.string,
  loading: _propTypes.default.oneOf(['eager', 'lazy']),
  multipleSwatches: _propTypes.default.bool,
  selectedSwatch: _propTypes.default.shape({
    color: _propTypes.default.string,
    basicColor: _propTypes.default.string,
    colorSwatchUrl: _propTypes.default.string,
    imageUrl: _propTypes.default.string,
    isAvailable: _propTypes.default.bool,
    skuId: _propTypes.default.string,
    id: _propTypes.default.string,
    isColorOfDefaultVariant: _propTypes.default.bool,
    url: _propTypes.default.string
  }),
  sizes: _propTypes.default.string,
  srcSetWidths: _propTypes.default.arrayOf(_propTypes.default.string),
  title: _propTypes.default.string,
  url: _propTypes.default.string
};
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(Image);